/* eslint-disable import/no-duplicates */
import FormSubmitButton from './FormSubmitButton';
import type FormHandler from './FormHandler';
import type { FormHandlerSubmitCallback } from './FormHandler';
import type { FormHandlerOptions } from './FormHandler';
import type { ValidationResult } from './ValidationService';
import { FormPostResult } from './IFormPostHandler';
import ControlGroup from './ControlGroup';
import type FormErrorMessenger from './FormErrorMessenger';
import announce from '../utils/screen-reader/announce';

export type ControlGroupResultPair = {
  controlGroup: ControlGroup;
  validationResult: ValidationResult;
};

export default class FormSubmitHandler {
  isSubmitting = false;

  constructor(private formHandler: FormHandler, private options: FormHandlerOptions, private errorMessenger: FormErrorMessenger) {
  }

  startListening() {
    this.formHandler.$form.addEventListener('submit', this.onSubmit);
  }

  stopListening() {
    this.formHandler.$form.removeEventListener('submit', this.onSubmit);
  }

  onSubmit = async (event?: Event) => {
    if (event) {
      event.preventDefault();
    }

    this.submit(this.options.onValidationSuccess);
  };

  submit = async (onSubmit?: FormHandlerSubmitCallback) => {
    if (this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;

    const { $submitBtn } = this.formHandler;

    FormSubmitButton.applyBusyStyling($submitBtn, { disableElement: false });

    announce('Loading');

    let response: FormPostResult;

    try {
      response = await this.formHandler.post();
    } catch (exception) {
      (this.options.onValidationAjaxException
        || (() => { window.location.href = '/error'; }))();

      return;
    }

    const { isValid } = response.validationResult;

    this.errorMessenger.clear();

    this.errorMessenger.processValidationResults(response.validationResult.validationResults);

    const stopSubmitting = () => {
      this.isSubmitting = false;
      FormSubmitButton.resetButtonStyling($submitBtn);
    };

    if (isValid) {
      if (onSubmit) {
        onSubmit({
          stopSubmitting,
          data: response.data,
        });
      } else {
        this.formHandler.$form.submit();
      }
    } else {
      stopSubmitting();
    }
  };
}
